import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters, {
	type endUserRequestModalQuery,
} from './__generated__/endUserRequestModalQuery.graphql';
import type { EndUserRequestModalProps } from './end-user-request-modal';

type Queries = {
	endUserRequestModalQuery: endUserRequestModalQuery;
};

export const entryPoint: EntryPoint<
	EntryPointComponent<
		Queries,
		Record<string, never>,
		EndUserRequestModalProps,
		Record<string, never>
	>,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_edition-awareness-end-user-request-modal" */ './end-user-request-modal'
			),
		{
			moduleId: 'edition-awareness-end-user-request-modal',
		},
	),
	getPreloadProps: () => ({
		entryPoints: {},
		extraProps: {},
		queries: {
			endUserRequestModalQuery: {
				parameters,
				variables: {},
			},
		},
	}),
});

export default entryPoint;
